import { Component } from '@angular/core';
import { Hero } from './hero/hero';
import { Benefits } from './benefits/benefits';

@Component({
  selector: 'app-main',
  imports: [
    Hero,
    Benefits,
  ],
  templateUrl: './main.html',
  styleUrl: './main.scss',
})
export class Main {

}
